export default __webpack_public_path__ + "static/media/bg_light_red.87aaa782.svg";